import angular from 'angular';
import StripWhiteSpaceDirective from './strip-whitespace.directive';

let StripWhiteSpaceModule = angular.module('Strip-white-space-module', [])

    .directive('stripWhitespace', StripWhiteSpaceDirective)

    .name;

export default StripWhiteSpaceModule;


// WEBPACK FOOTER //
// ./client/app/common/strip-whitespace/index.js